import { h } from "preact";
import { useState, useEffect, useCallback, useContext } from "preact/hooks";
import { Grid, Typography, Paper, TextField, Modal, Button } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { makeStyles } from "@mui/styles";
import PostAddIcon from "@mui/icons-material/PostAdd";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import EventIcon from "@mui/icons-material/Event";
import EuroIcon from "@mui/icons-material/Euro";

import { SessionContext } from "../../SessionContext";

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: "6px 16px",
	},
	secondaryTail: {
		backgroundColor: theme.palette.secondary.main,
	},
}));

const GetIcon = (c) => {
	switch (c) {
		case "A":
			return <AccessibilityNewIcon />;
			break;
		case "D":
			return <PostAddIcon />;
			break;
		case "V":
			return <EventIcon />;
			break;
		case "F":
			return <EuroIcon />;
			break;
	}
};
const handleClick = () => {
	window.location.replace("/dataroom");
};
const TLItem = ({ t, b, i, c, r }) => {
	return (
		<TimelineItem onClick={handleClick}>
			<TimelineOppositeContent>
				<Typography variant="body2" color="textSecondary" style="padding-top:15px;">
					{i}
				</Typography>
			</TimelineOppositeContent>
			<TimelineSeparator>
				<TimelineDot>{GetIcon(c)}</TimelineDot>
				<TimelineConnector />
			</TimelineSeparator>
			<TimelineContent>
				<Paper elevation={3} style="padding: 10px;">
					<Typography variant="h6" component="h1">
						{t}
					</Typography>
					<Typography>{b}</Typography>
				</Paper>
			</TimelineContent>
		</TimelineItem>
	);
};

export default function DealNotifications() {
	const classes = useStyles();
	const [state, setState] = useContext(SessionContext);
	const [notifs, setNotifs] = useState([]);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/dnotifs", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setNotifs(res.pld);

						break;
					case "err":
						break;
					default:
						break;
				}
			});

		setState((state) => ({
			...state,
			unread: 0,
		}));
	}, []);

	return (
		<div style="margin-top: 40px; padding-left: 100px; padding-right: 100px;">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 20px">
						<Typography variant="h3">Actualité du deal</Typography>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Timeline align="alternate">
						{notifs.map((notif) => {
							return <TLItem b={notif.b} i={notif.i} c={notif.c} r={notif.r} s={notif.s} t={notif.t} />;
						})}
					</Timeline>
				</Grid>
			</Grid>
		</div>
	);
}
